<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("warehouse_items")}}</h4>
                <p class="text-subtitle-1">{{$t("warehouse_item_location_and_min_quantity")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" @click="handleCreateWarehouseItem" block>
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("attach_item_to_warehouse")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleSearch">
                    <v-icon left>mdi-magnify</v-icon>
                    {{$t("search")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <WarehouseItemList/>
            </v-col>
        </v-row>
        <v-dialog v-model="searchDialogShown" max-width="350">
            <v-sheet>
                <v-toolbar dense flat>
                    <v-toolbar-title>
                        Search
                    </v-toolbar-title>
                </v-toolbar>
                <div class="pa-3">
                    <v-row>
                        <v-col>
                            <WarehouseItemListSearchForm v-model="searchForm"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-btn block depressed color="primary" @click="search">
                                <v-icon left>mdi-magnify</v-icon>
                                search
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-sheet>
        </v-dialog>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import WarehouseItemListSearchForm from './../../components/warehouse/WarehouseItemListSearchForm';
import WarehouseItemList from './../../components/warehouse/WarehouseItemList';

import { mapActions } from 'vuex';
export default {
    name: "WarehouseItemListView",
    components: {
        WarehouseItemListSearchForm,
        WarehouseItemList
    },
    data() {
        return {
            searchDialogShown: false,
            searchForm: null,
            breadcrumbsItems: [
                {text: 'Warehouse & Inventory'},
                {text: 'Items'},
                {text: "Warehouse Items"}
            ],
            loading: false,
            warehouseId: null,
            // warehouse: null,
            perm: permissions
        }
    },
    computed: {
        // ...mapGetters({
        //     warehouseItemParams: "stock/warehouseItem/list/params"
        // })
    },
    watch: {
        // "warehouseItemParams.warehouse_id": {
        //     handler(warehouseId) {
        //         this.warehouseId = warehouseId;
        //         this.fetchWarehouseAysnc();
        //     }
        // }
    },
    methods: {
        ...mapActions({
            searchParams: "stock/warehouseItem/list/updateParams",
            findWarehouseByID: "warehouse/warehouse/findByID",
            snackbar: "ui/snackbar/show",
            searchWarehouseItems: "stock/warehouseItem/list/updateParams",
            warehouseItemParams: "stock/warehouseItem/list/params",
            hasPermission: "authentication/hasPermission"
        }),
        handleCreateWarehouseItem() {
            this.$router.push({ name: "WarehouseItemCreate" })
        },
        handleSearch() {
            this.searchDialogShown = true;
        },
        search() {
            this.searchParams({...this.searchForm })
            this.searchDialogShown = false

        },
        // fetchWarehouseAysnc() {
        //     this.loading = true;
        //     this.findWarehouseByID(this.warehouseId).then(response => {
        //         this.warehouse = response.data;
        //     }).catch(error => {
        //         let message = error.response ? error.response.data.message : error
        //         this.snackbar({ text: message, color: "error"})
        //     }).finally(() => {
        //         this.loading = false;
        //     })
        // }
    },
    mounted() {
        if(this.$route.params.warehouseId) {
            this.searchForm = {...this.searchForm, warehouse_id: this.$route.params.warehouseId};
            this.search()
        }
    }
}
</script>

<style>

</style>